export const numberOfEntrepreneursEnrolledTotalCalculation = (props: any) => {
    const {uoas, projectsBreakdown} = props;

    if (!projectsBreakdown) return 0;

    const projectsLevelIds = projectsBreakdown.levels.map((level: any) => level.id);

    return uoas.filter((uoa: any) => uoa.levels.some((level: number) => projectsLevelIds.includes(level))).length;
}